import { DocumentsSection } from "Components/AML/AMLUserDetail/shared/DocumentsSection";
import { NaturalPersonBasicInfoSection } from "Components/AML/AMLUserDetail/shared/NaturalPersonBasicInfoSection";
import { VerificationsSection } from "Components/AML/AMLUserDetail/shared/VerificationsSection";
import type { PartyDto, UserVerificationDto } from "Infrastructure/Api/Api";

type Props = {
  partyData: PartyDto;
  verificationData: UserVerificationDto;
};

export const NaturalPersonContent = ({
  partyData,
  verificationData,
}: Props) => (
  <>
    <NaturalPersonBasicInfoSection partyData={partyData} />
    <DocumentsSection partyData={partyData} />
    <VerificationsSection
      verificationData={verificationData}
      partyType={partyData.type}
    />
  </>
);
